// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Floating “Ask Yovo Assist” bar — mobile only (<768px via parent display rules).
 * Figma 6544:96165 — 1.5px gradient border, #FBFBFB fill, 64px radius, shadow.
 * Hide any copy, including a prerendered one React does not control, once Assist is open. */
body:has([data-testid='yovo-mobile-chat-overlay']) [data-yovo-mobile-assist-bar] {
  display: none !important;
}

.yovo-mobile-assist-bar-inner {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 48px;
  box-sizing: border-box;
  gap: 8px;
  padding: 8px 8px 8px 24px;
  border-radius: 64px;
  border: 1.5px solid transparent;
  background-color: #fbfbfb;
  background-image:
    linear-gradient(#fbfbfb, #fbfbfb),
    linear-gradient(
      -4deg,
      rgba(187, 0, 255, 0.44) 0%,
      rgba(0, 178, 255, 0.44) 30%,
      rgba(108, 39, 255, 0.44) 65%,
      rgba(255, 0, 0, 0.44) 100%
    );
  background-origin: border-box;
  background-clip: padding-box, border-box;
  box-shadow: 0 4px 8px #d2d2d2;
  pointer-events: auto;
}

.yovo-mobile-assist-bar-inner input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-family: 'Host Grotesk', sans-serif;
  font-size: 16px;
  line-height: 1.25rem;
  letter-spacing: 0.009375em;
  color: #1a1827;
  appearance: none;
}

.yovo-mobile-assist-bar-inner input::placeholder {
  color: #717180;
  opacity: 1;
}

.yovo-mobile-assist-send {
  width: 32px;
  height: 32px;
  padding: 6.4px;
  box-sizing: border-box;
  background: #1a1827;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/components/Homepage/styles/MobileBottomNav.css"],"names":[],"mappings":"AAAA;;4FAE4F;AAC5F;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;EACzB;;;;;;;;KAQG;EACH,6BAA6B;EAC7B,wCAAwC;EACxC,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,cAAc;EAEd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,wCAAwC;AAC1C","sourcesContent":["/* Floating “Ask Yovo Assist” bar — mobile only (<768px via parent display rules).\n * Figma 6544:96165 — 1.5px gradient border, #FBFBFB fill, 64px radius, shadow.\n * Hide any copy, including a prerendered one React does not control, once Assist is open. */\nbody:has([data-testid='yovo-mobile-chat-overlay']) [data-yovo-mobile-assist-bar] {\n  display: none !important;\n}\n\n.yovo-mobile-assist-bar-inner {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-height: 48px;\n  box-sizing: border-box;\n  gap: 8px;\n  padding: 8px 8px 8px 24px;\n  border-radius: 64px;\n  border: 1.5px solid transparent;\n  background-color: #fbfbfb;\n  background-image:\n    linear-gradient(#fbfbfb, #fbfbfb),\n    linear-gradient(\n      -4deg,\n      rgba(187, 0, 255, 0.44) 0%,\n      rgba(0, 178, 255, 0.44) 30%,\n      rgba(108, 39, 255, 0.44) 65%,\n      rgba(255, 0, 0, 0.44) 100%\n    );\n  background-origin: border-box;\n  background-clip: padding-box, border-box;\n  box-shadow: 0 4px 8px #d2d2d2;\n  pointer-events: auto;\n}\n\n.yovo-mobile-assist-bar-inner input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: 'Host Grotesk', sans-serif;\n  font-size: 16px;\n  line-height: 1.25rem;\n  letter-spacing: 0.009375em;\n  color: #1a1827;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.yovo-mobile-assist-bar-inner input::placeholder {\n  color: #717180;\n  opacity: 1;\n}\n\n.yovo-mobile-assist-send {\n  width: 32px;\n  height: 32px;\n  padding: 6.4px;\n  box-sizing: border-box;\n  background: #1a1827;\n  border-radius: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
